module.exports = __webpack_public_path__ + "static/media/camping-01.827cadfd.jpg";